import { Page } from '@/core/architecture'

import { NotificationsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * Notifications Page
 * Implemented as a practical sample.
 */
export const Notifications: Page = () => {
  const { state, actions } = useViewModel()

  return <NotificationsTemplate state={state} {...actions} />
}
